import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, DeleteOutlined, Popconfirm, Space } from "@ctra/components";
import { EnterpriseAppState, Events } from "@ctra/api";
import { Enterprise as Content, useTranslation } from "@ctra/i18n";
import { isPending } from "@ctra/utils";

import { useEvent, testIds } from "@events";

/**
 * Generic Event call to action component
 * @constructor
 */
export const IdaQnAsEventCta: FC = () => {
  const dispatch = useDispatch();
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState<boolean>(false);
  const { t } = useTranslation();

  const {
    getContext,
    event: {
      id,
      source: { type, id: sourceID }
    }
  } = useEvent();

  const { relatedAnnotationID } = getContext();

  const {
    events: {
      list: {
        entry: {
          cta: {
            remove: { confirm, yes, no }
          }
        }
      }
    }
  } = Content;

  /**
   * Tell if the given event is being deleted
   */
  const isDeleting = useSelector<EnterpriseAppState, boolean>((state) =>
    isPending(state, Events.types.DELETE_EVENT, { primaryValue: id })
  );

  return (
    <Space>
      {!!relatedAnnotationID && (
        <Popconfirm
          visible={confirmDeleteVisible}
          placement="topRight"
          title={t<string>(confirm)}
          onConfirm={() => {
            dispatch(Events.actions.deleteEvent.start(id, type, sourceID));
          }}
          okText={t<string>(yes)}
          okButtonProps={{ loading: isDeleting }}
          onCancel={() => setConfirmDeleteVisible(false)}
          cancelText={t<string>(no)}
        >
          <Button
            data-testid={testIds.cta.button.delete}
            onClick={() => setConfirmDeleteVisible(true)}
            size="small"
            icon={<DeleteOutlined />}
          />
        </Popconfirm>
      )}
    </Space>
  );
};
